module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_a/og-aoj_a-31543150941044321411f56b2ed96e61.png";